import { render, staticRenderFns } from "./AutoShutdownSettingsRoot.vue?vue&type=template&id=ba2132ae"
import script from "./AutoShutdownSettingsRoot.vue?vue&type=script&lang=ts"
export * from "./AutoShutdownSettingsRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports